import React from 'react';
import { ConverToTextComponent } from './../UI-Components'

export default ({ id, value, option, getAnswer, checkedAnswers, i, isMathType, isSelect }) => {
    return (
        <div style={{
            marginBottom: 8, border: "0.5 1px #DDE7F2", width: '85%',
            height: 50, backgroundColor: '#FFFFFF',
            borderRadius: 5, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginTop: 4, display: 'flex'
        }}
             onClick = {() => checkedAnswers(id, value)}
        >

            <div className='mx-2'>
                {
                    getAnswer(id) === value 
                        ?
                        <div
                            style={{
                                width: 28, height: 28,
                                border: "2px solid #85D982",
                                borderRadius: 100,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fff',
                                overflow: 'hidden',
                            }}>

                            <div
                                style={{
                                    borderRadius: 100, backgroundColor: 'green',
                                    width: 14, height: 14
                                }}
                            />
                        </div>
                        :
                        <div
                            style={{
                                width: 28, height: 28,
                                border: "2px solid #DDE7F2",
                                borderRadius: 100,
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fff',
                                overflow: 'hidden',

                            }}>

                            <div

                                color={'green'}
                                style={{
                                    borderRadius: 100, backgroundColor: '#fff',
                                    width: 14, height: 14
                                }}
                            />
                        </div>


                }
            </div>
            <div className='mx-1' style={{ width: '95%', display: 'flex', flexWrap: 'wrap' }}>
            <ConverToTextComponent text={option} isBold isMathType={isMathType} />
            </div>

        </div>

    )
}